(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7615],{

/***/ 87757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(35666);


/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15482);
/* harmony import */ var _utils_shapes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73242);
/* harmony import */ var _utils_replaceApplicationStatePlaceholders__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98012);
var _excluded=["url","applicationState"];var ScriptLoader=function ScriptLoader(_ref){var url=_ref.url,applicationState=_ref.applicationState,props=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref,_excluded);return/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_helmet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP,null,/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("script",(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({src:(0,_utils_replaceApplicationStatePlaceholders__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(url,applicationState)},props)));};ScriptLoader.defaultProps={type:'text/javascript'};ScriptLoader.propTypes={/**
   * The url of the script to load
   */url:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),/**
   * An object of application data that can be used in the url
   */applicationState:_utils_shapes__WEBPACK_IMPORTED_MODULE_6__/* .applicationStateShape */ .Y1,/**
   * The script type
   */type:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired)};/* harmony default export */ __webpack_exports__["Z"] = (ScriptLoader);
//# sourceMappingURL=ScriptLoader.js.map

/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({smallMinBreakpoint:'xs',largeMinBreakpoint:'lg'}));
//# sourceMappingURL=ResponsiveContext.js.map

/***/ }),

/***/ 40383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _models_PartnerProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42796);
/* harmony import */ var _utils_getByPath__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3043);
var usePartner=function usePartner(key){var partner=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_models_PartnerProvider__WEBPACK_IMPORTED_MODULE_1__/* .PartnerContext */ .Hc);return typeof key==='string'&&partner?(0,_utils_getByPath__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(partner,key):partner;};/* harmony default export */ __webpack_exports__["Z"] = (usePartner);
//# sourceMappingURL=usePartner.js.map

/***/ }),

/***/ 42796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hc": function() { return /* binding */ PartnerContext; },
  "ZP": function() { return /* binding */ models_PartnerProvider; }
});

// UNUSED EXPORTS: PartnerConsumer

// NAMESPACE OBJECT: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/index.js
var Trackers_namespaceObject = {};
__webpack_require__.r(Trackers_namespaceObject);
__webpack_require__.d(Trackers_namespaceObject, {
  "FacebookPixel": function() { return Trackers_FacebookPixel; },
  "GoogleAnalytics": function() { return Trackers_GoogleAnalytics; },
  "Pinterest": function() { return Trackers_Pinterest; },
  "Tealium": function() { return Trackers_Tealium; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/buildURL.js
/**
 * Gets a link for a specified page/request
 *
 * @param {string}  url    The base url
 * @param {Object=} params Object of parameters for the URL
 *
 * @returns {string} Returns the requested URL
 *//* harmony default export */ var buildURL = (function(url){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var query=[];// create an array of params
if((0,esm_typeof/* default */.Z)(params)==='object'){try{for(var _i=0,_Object$keys=Object.keys(params);_i<_Object$keys.length;_i++){var param=_Object$keys[_i];query[query.length]="".concat(encodeURIComponent(param),"=").concat(encodeURIComponent(params[param]));}}catch(e){}}return url+(query.length>0?"?".concat(query.join('&').replace(/%20/g,'+')):'');});
//# sourceMappingURL=buildURL.js.map
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/shapes.js
var shapes = __webpack_require__(73242);
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/replaceApplicationStatePlaceholders.js
var replaceApplicationStatePlaceholders = __webpack_require__(98012);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/verifyParameters.js
var verifyParameters=function verifyParameters(parameters){var verified=true;Object.values(parameters).forEach(function(value){if(value===null){verified=false;}});return verified;};/* harmony default export */ var utils_verifyParameters = (verifyParameters);
//# sourceMappingURL=verifyParameters.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/TrackingPixel/TrackingPixel.js
function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var TrackingPixel=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(TrackingPixel,_React$Component);var _super=_createSuper(TrackingPixel);function TrackingPixel(){(0,classCallCheck/* default */.Z)(this,TrackingPixel);return _super.apply(this,arguments);}(0,createClass/* default */.Z)(TrackingPixel,[{key:"render",value:function render(){var _this$props=this.props,type=_this$props.type,url=_this$props.url,events=_this$props.events,applicationState=_this$props.applicationState;var pageType=applicationState.pageType;// only return a component if window and all required props exists
/* istanbul ignore if */if((typeof window==="undefined"?"undefined":(0,esm_typeof/* default */.Z)(window))!=='object'||(0,esm_typeof/* default */.Z)(applicationState)!=='object'||(0,esm_typeof/* default */.Z)(events)!=='object'){return null;}var eventTypes={init:true,pageview:true,landing:pageType==='landing'||pageType==='landing_flights',index:pageType==='index',search:pageType==='search_results'||pageType==='search_results_flights',details:pageType==='product_details',checkout:pageType==='checkout_process',success:pageType==='post_booking',promotion:pageType==='promotion',others:pageType==='others'};var src={};var parameters;// handle events
Object.keys(events).forEach(function(event){// make sure the event type is valid
if(eventTypes[event]){var eventUrl=url||events[event].url;parameters=(0,replaceApplicationStatePlaceholders/* default */.Z)(events[event].parameters,applicationState);// verify that we have values for all parameters
if(eventUrl&&utils_verifyParameters(parameters)){src[event]=buildURL((0,replaceApplicationStatePlaceholders/* default */.Z)(eventUrl,applicationState),parameters);}}});if(!Object.keys(src).length){return null;}return Object.keys(src).map(function(key){switch(type){case'image':return/*#__PURE__*/react.createElement("img",{key:key,style:{position:'absolute'},src:src[key],alt:"","data-testid":"tracking-pixel"});case'iframe':return/*#__PURE__*/react.createElement("iframe",{key:key,title:key,style:{display:'none'},width:"1",height:"1",frameBorder:"0",src:src[key],"data-testid":"tracking-pixel"});default:return null;}});}}]);return TrackingPixel;}(react.Component);TrackingPixel.propTypes={/**
   * The type of tracking pixel, supports `image` and `iframe`
   */type:prop_types_default().oneOf(['image','iframe']).isRequired,/**
   * The url of the pixel. This url will be loaded into an image tag for each event.
   */url:(prop_types_default()).string,/**
   * An object of events specifying when to load the pixel and what data to pass.
   */events:(prop_types_default()).object,/**
   * An object of application data that can be used for events.
   */applicationState:shapes/* applicationStateShape */.Y1};/* harmony default export */ var TrackingPixel_TrackingPixel = (TrackingPixel);
//# sourceMappingURL=TrackingPixel.js.map
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87757);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/Tracker.js
function Tracker_createSuper(Derived){var hasNativeReflectConstruct=Tracker_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function Tracker_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var Tracker=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(Tracker,_React$Component);var _super=Tracker_createSuper(Tracker);function Tracker(props){var _this;(0,classCallCheck/* default */.Z)(this,Tracker);_this=_super.call(this,props);_this.initialized=false;_this.pageType=null;_this.getEventTypes=_this.getEventTypes.bind((0,assertThisInitialized/* default */.Z)(_this));_this.handleEvents=_this.handleEvents.bind((0,assertThisInitialized/* default */.Z)(_this));return _this;}(0,createClass/* default */.Z)(Tracker,[{key:"getEventTypes",value:function getEventTypes(firstLoad){var pageType=this.props.applicationState.pageType;return{init:firstLoad,pageview:firstLoad?true:this.pageType!==pageType,landing:pageType==='landing'||pageType==='landing_flights',index:pageType==='index',search:pageType==='search_results'||pageType==='search_results_flights',details:pageType==='product_details',checkout:pageType==='checkout_process',success:pageType==='post_booking',promotion:pageType==='promotion',others:pageType==='others'};}},{key:"handleEvents",value:function handleEvents(){var _this2=this;var firstLoad=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _this$props=this.props,events=_this$props.events,applicationState=_this$props.applicationState;if(!events){return;}Object.keys(events).forEach(function(eventType){// make sure the event type is valid
if(_this2.getEventTypes(firstLoad)[eventType]){if(_this2.isArrayOfEvents(events[eventType])){events[eventType].forEach(function(event){var args=(0,replaceApplicationStatePlaceholders/* default */.Z)(event,applicationState);_this2.callEvent(eventType,firstLoad,args);});}else{var args=(0,replaceApplicationStatePlaceholders/* default */.Z)(events[eventType],applicationState);_this2.callEvent(eventType,firstLoad,args);}}});}},{key:"isArrayOfEvents",value:function isArrayOfEvents(events){return Array.isArray(events)&&events.length>0&&events[0].length>0&&Array.isArray(events[0]);}},{key:"callEvent",value:function callEvent(eventType,firstLoad,args){// verify that we have values for all arguments
if(utils_verifyParameters(args)){this.event.apply(this,[eventType,firstLoad].concat((0,toConsumableArray/* default */.Z)(args)));}}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;var _this$props2=this.props,applicationState=_this$props2.applicationState,onInit=_this$props2.onInit;/* istanbul ignore else  */if((typeof window==="undefined"?"undefined":(0,esm_typeof/* default */.Z)(window))==='object'){this.init().then(function(){_this3.initialized=true;_this3.handleEvents(true);_this3.pageType=applicationState.pageType;onInit(true,_this3.pageType);});}else{onInit(false);}}},{key:"componentDidUpdate",value:function componentDidUpdate(){/* istanbul ignore else  */if((typeof window==="undefined"?"undefined":(0,esm_typeof/* default */.Z)(window))==='object'&&this.verifyInit()){var nextPageType=this.props.applicationState.pageType;if(this.pageType!==nextPageType){this.handleEvents();this.pageType=nextPageType;this.props.onInit(true,this.pageType);}}}},{key:"verifyInit",value:function verifyInit(){return this.initialized;}/* istanbul ignore next */},{key:"init",value:function(){var _init=_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(){return regenerator_default().wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:case"end":return _context.stop();}}},_callee);}));function init(){return _init.apply(this,arguments);}return init;}()/* istanbul ignore next */},{key:"event",value:function event(){// is overridden
}},{key:"render",value:function render(){return null;}}]);return Tracker;}(react.Component);Tracker.defaultProps={onInit:function onInit(){}};Tracker.propTypes={trackerName:(prop_types_default()).string,events:(prop_types_default()).object,applicationState:shapes/* applicationStateShape */.Y1,onInit:(prop_types_default()).func};/* harmony default export */ var Trackers_Tracker = (Tracker);
//# sourceMappingURL=Tracker.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/GoogleAnalytics.js
function GoogleAnalytics_createSuper(Derived){var hasNativeReflectConstruct=GoogleAnalytics_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function GoogleAnalytics_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var GoogleAnalytics=/*#__PURE__*/function(_Tracker){(0,inherits/* default */.Z)(GoogleAnalytics,_Tracker);var _super=GoogleAnalytics_createSuper(GoogleAnalytics);function GoogleAnalytics(){var _this;(0,classCallCheck/* default */.Z)(this,GoogleAnalytics);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=_super.call.apply(_super,[this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this),"ecommerceLoaded",false);return _this;}(0,createClass/* default */.Z)(GoogleAnalytics,[{key:"init",value:function(){var _init=_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(){return regenerator_default().wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:/* istanbul ignore next */!function(i,s,o,g,r,a,m){if(i[r])return;i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){;(i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);}(window,document,'script','https://www.google-analytics.com/analytics.js','ga');/* eslint-enable no-unused-expressions */case 1:case"end":return _context.stop();}}},_callee);}));function init(){return _init.apply(this,arguments);}return init;}()},{key:"event",value:function event(_event,firstLoad){var _window;if(_event==='success'&&!this.ecommerceLoaded){var trackerName=this.props.trackerName;window.ga("".concat(trackerName&&trackerName+'.'||'',"require"),'ecommerce');this.ecommerceLoaded=true;}for(var _len2=arguments.length,args=new Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){args[_key2-2]=arguments[_key2];}(_window=window).ga.apply(_window,args);}}]);return GoogleAnalytics;}(Trackers_Tracker);/* harmony default export */ var Trackers_GoogleAnalytics = (GoogleAnalytics);
//# sourceMappingURL=GoogleAnalytics.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/FacebookPixel.js
function FacebookPixel_createSuper(Derived){var hasNativeReflectConstruct=FacebookPixel_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function FacebookPixel_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var FacebookPixel=/*#__PURE__*/function(_Tracker){(0,inherits/* default */.Z)(FacebookPixel,_Tracker);var _super=FacebookPixel_createSuper(FacebookPixel);function FacebookPixel(){(0,classCallCheck/* default */.Z)(this,FacebookPixel);return _super.apply(this,arguments);}(0,createClass/* default */.Z)(FacebookPixel,[{key:"init",value:function(){var _init=_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(){return regenerator_default().wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:/* istanbul ignore next */!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments);};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');case 1:case"end":return _context.stop();}}},_callee);}));function init(){return _init.apply(this,arguments);}return init;}()},{key:"event",value:function event(_event,firstLoad){var _window;for(var _len=arguments.length,args=new Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){args[_key-2]=arguments[_key];}(_window=window).fbq.apply(_window,args);}}]);return FacebookPixel;}(Trackers_Tracker);/* harmony default export */ var Trackers_FacebookPixel = (FacebookPixel);
//# sourceMappingURL=FacebookPixel.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/Pinterest.js
function Pinterest_createSuper(Derived){var hasNativeReflectConstruct=Pinterest_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function Pinterest_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var Pinterest=/*#__PURE__*/function(_Tracker){(0,inherits/* default */.Z)(Pinterest,_Tracker);var _super=Pinterest_createSuper(Pinterest);function Pinterest(){(0,classCallCheck/* default */.Z)(this,Pinterest);return _super.apply(this,arguments);}(0,createClass/* default */.Z)(Pinterest,[{key:"init",value:function(){var _init=_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(){return regenerator_default().wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:/* istanbul ignore next */!function(w,d,s,e,n,t,r){if(w.pintrk)return;w.pintrk=function(){w.pintrk.queue.push(Array.prototype.slice.call(arguments));};n=w.pintrk;n.version='3.0';n.queue=[];t=d.createElement(s);t.async=!0;t.src=e;r=d.getElementsByTagName(s)[0];r.parentNode.insertBefore(t,r);}(window,document,'script','https://s.pinimg.com/ct/core.js');case 1:case"end":return _context.stop();}}},_callee);}));function init(){return _init.apply(this,arguments);}return init;}()},{key:"event",value:function event(_event,firstLoad){var _window;for(var _len=arguments.length,args=new Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){args[_key-2]=arguments[_key];}(_window=window).pintrk.apply(_window,args);}}]);return Pinterest;}(Trackers_Tracker);/* harmony default export */ var Trackers_Pinterest = (Pinterest);
//# sourceMappingURL=Pinterest.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/Tealium.js
function Tealium_createSuper(Derived){var hasNativeReflectConstruct=Tealium_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function Tealium_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var Tealium=/*#__PURE__*/function(_Tracker){(0,inherits/* default */.Z)(Tealium,_Tracker);var _super=Tealium_createSuper(Tealium);function Tealium(){var _this;(0,classCallCheck/* default */.Z)(this,Tealium);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=_super.call.apply(_super,[this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this),"resolveInit",void 0);(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this),"TEALIUM_LOADED_EVENT_TYPE",'TealiumLoaded');return _this;}(0,createClass/* default */.Z)(Tealium,[{key:"init",value:function(){var _init=_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(){var _this2=this;var tealiumLoaded;return regenerator_default().wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:tealiumLoaded=new Event('TealiumLoaded');return _context.abrupt("return",new Promise(function(resolve){var _this2$props$url,_window$utag_data;_this2.resolveInit=resolve;_this2.onTealiumLoaded();var env=_this2.props.env;var url=(_this2$props$url=_this2.props.url)===null||_this2$props$url===void 0?void 0:_this2$props$url[env];window.utag_data=(_window$utag_data=window.utag_data)!==null&&_window$utag_data!==void 0?_window$utag_data:{};/* istanbul ignore next */ /* istanbul ignore next */!function(a,b,c,d){a=url;b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;a=b.getElementsByTagName(c)[0];if(a){a.parentNode.insertBefore(d,a);}else{b.body.appendChild(d);}d.handlerFlag=0;d.onreadystatechange=function(){if((this.readyState==='complete'||this.readyState==='loaded')&&!d.handlerFlag){d.handlerFlag=1;document.dispatchEvent(tealiumLoaded);}};d.onload=function(){if(!d.handlerFlag){d.handlerFlag=1;document.dispatchEvent(tealiumLoaded);}};}();}));case 2:case"end":return _context.stop();}}},_callee);}));function init(){return _init.apply(this,arguments);}return init;}()/* istanbul ignore next */},{key:"onTealiumLoaded",value:function onTealiumLoaded(){var _this3=this;document.addEventListener(this.TEALIUM_LOADED_EVENT_TYPE,function(){_this3.resolveInit();},false);}/* istanbul ignore next */},{key:"event",value:function event(_event,firstLoad){if(!(firstLoad&&_event==='pageview')){var _window$utag;for(var _len2=arguments.length,args=new Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){args[_key2-2]=arguments[_key2];}(_window$utag=window.utag)===null||_window$utag===void 0?void 0:_window$utag.track.apply(_window$utag,args);}}}]);return Tealium;}(Trackers_Tracker);/* harmony default export */ var Trackers_Tealium = (Tealium);
//# sourceMappingURL=Tealium.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/Trackers/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/components/ScriptLoader/ScriptLoader.js
var ScriptLoader = __webpack_require__(62951);
;// CONCATENATED MODULE: ./node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/ThemeProvider/ThemeProvider.js + 1 modules
var ThemeProvider = __webpack_require__(8057);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/isMobileDevice.js
/**
 * Determines whether the provided navigator user agent belongs to a mobile device
 *
 * @param {Object}  navigator    The window navigator
 *
 * @returns {boolean} Whether device is mobile
 */var isMobileDevice=function isMobileDevice(navigator){if(!navigator||!navigator.userAgent){return false;}return!!(navigator.userAgent.match(/Android/i)||navigator.userAgent.match(/webOS/i)||navigator.userAgent.match(/iPhone/i)||navigator.userAgent.match(/iPad/i)||navigator.userAgent.match(/iPod/i)||navigator.userAgent.match(/BlackBerry/i)||navigator.userAgent.match(/Windows Phone/i));};/* harmony default export */ var utils_isMobileDevice = (isMobileDevice);
//# sourceMappingURL=isMobileDevice.js.map
// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(15482);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/utils/getPageType.js
var pageTypes={search_results:/^.+\/shop\/search\/(\w+\/)?(flights|hotels)?\?.*(id=\w+-\w+-\w+-\w+-\w+).+$/,product_details:/^.+((\/shop\/search\/(\w+\/)?(hotels|flights)\/)|(\/relax\/(\w+\/)?at\/)|(\/m\/fly\/search\/(\w+\/)?.+?\/details\/)).+$/,checkout_process:/^.+(\/cart\/checkout\/|\/shop\/search\/(\w+\/)?itinerary).+$/,post_booking:/^.+\/travel-itinerary.+$/,promotion:/^.+\/wl\/promotions\/(\w+)?\/?.*$/,about:/^.+\/pages\/about$/,index:/^.+\/shop\/search(\/\w+)?\/?.*$/,landing:/^.+(\/vacationpackages\/|\/wl\/)(\w+)?\/?.*$/,landing_flights:/^.+\/flights(\/\w+)?\/?.*$/,search_results_flights:/^\S*\/m\/fly\/search\/(?:\w{3}-\w{3}-\d{8}\/).+$/,others:/^.+$/};var getType=function getType(pageType){switch(pageType){case'index':case'landing':case'landing_flights':return'landing';case'search_results':case'search_results_flights':return'search';case'product_details':return'details';case'checkout_process':return'checkout';case'post_booking':return'book';case'promotion':return'promotion';case'about':return'about';default:return'other';}};var getPageType=function getPageType(url){return Object.keys(pageTypes).find(function(type){return pageTypes[type].test(url);});};
//# sourceMappingURL=getPageType.js.map
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/contexts/ResponsiveContext/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(30630);
// EXTERNAL MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/models/SSOProvider/SSOProvider.js
var SSOProvider = __webpack_require__(2433);
;// CONCATENATED MODULE: ./node_modules/@pcln/whitelabel-components/dist/esm/models/PartnerProvider/index.js
var _excluded=["href"];function PartnerProvider_createSuper(Derived){var hasNativeReflectConstruct=PartnerProvider_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function PartnerProvider_isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var PartnerContext=/*#__PURE__*/react.createContext();var PartnerConsumer=PartnerContext.Consumer;var UPDATE_PARTNER_TRACKING_PIXEL='UPDATE_PARTNER_TRACKING_PIXEL';var UPDATE_PARTNER_APPLICATION_STATE='UPDATE_PARTNER_APPLICATION_STATE';var UPDATE_PARTNER_OMITTED='UPDATE_PARTNER_OMITTED';var checkOmit=function checkOmit(omit,component){return Array.isArray(omit)&&omit.includes(component)||omit===true;};var pixelTypes=(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({},Trackers_namespaceObject),{},{image:TrackingPixel_TrackingPixel,iframe:TrackingPixel_TrackingPixel});/**
 * A provider that can be used to wrap your application and set a partner
 *
 * @param {Object} partner
 * @param {*}      children
 *
 * @returns {null|React.Component}
 */var PartnerProvider=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(PartnerProvider,_React$Component);var _super=PartnerProvider_createSuper(PartnerProvider);function PartnerProvider(props){var _props$trackingPixelP,_props$applicationSta,_props$renderTracking;var _this;(0,classCallCheck/* default */.Z)(this,PartnerProvider);_this=_super.call(this,props);var trackingPixelParameters=(_props$trackingPixelP=props===null||props===void 0?void 0:props.trackingPixelParameters)!==null&&_props$trackingPixelP!==void 0?_props$trackingPixelP:{};var applicationState=(_props$applicationSta=props===null||props===void 0?void 0:props.applicationState)!==null&&_props$applicationSta!==void 0?_props$applicationSta:{};_this.state={omit:{trackingPixels:checkOmit(props.omit,'trackingPixels')||!((_props$renderTracking=props===null||props===void 0?void 0:props.renderTrackingPixel)!==null&&_props$renderTracking!==void 0?_props$renderTracking:true),headScripts:checkOmit(props.omit,'headScripts')},applicationState:es.all([PartnerProvider.getApplicationState(),trackingPixelParameters,applicationState]),prevApplicationProps:es(trackingPixelParameters,applicationState)};_this.shouldOmit=_this.shouldOmit.bind((0,assertThisInitialized/* default */.Z)(_this));_this.updateOmit=_this.updateOmit.bind((0,assertThisInitialized/* default */.Z)(_this));_this.updateTrackingPixel=_this.updateTrackingPixel.bind((0,assertThisInitialized/* default */.Z)(_this));_this.updateApplicationState=_this.updateApplicationState.bind((0,assertThisInitialized/* default */.Z)(_this));return _this;}(0,createClass/* default */.Z)(PartnerProvider,[{key:"shouldOmit",value:function shouldOmit(component){return this.state.omit[component];}},{key:"updateTrackingPixel",value:function updateTrackingPixel(_ref){var _ref$renderTrackingPi=_ref.renderTrackingPixel,renderTrackingPixel=_ref$renderTrackingPi===void 0?this.shouldOmit('trackingPixels')===false:_ref$renderTrackingPi,_ref$trackingPixelPar=_ref.trackingPixelParameters,trackingPixelParameters=_ref$trackingPixelPar===void 0?this.state.applicationState:_ref$trackingPixelPar;this.updateApplicationState(trackingPixelParameters);this.updateOmit({trackingPixels:renderTrackingPixel===false});}},{key:"updateApplicationState",value:function updateApplicationState(applicationState){this.setState(function(prevState){return{applicationState:(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({},prevState.applicationState),applicationState)};});}},{key:"updateOmit",value:function updateOmit(omitted){this.setState(function(prevState){return{omit:(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({},prevState.omit),omitted)};});}},{key:"componentDidMount",value:function componentDidMount(){// Listen for events
window.addEventListener(UPDATE_PARTNER_TRACKING_PIXEL,this.updateTrackingPixel);window.addEventListener(UPDATE_PARTNER_APPLICATION_STATE,this.updateApplicationState);window.addEventListener(UPDATE_PARTNER_OMITTED,this.updateOmit);}},{key:"componentWillUnmount",value:function componentWillUnmount(){// Remove listeners
window.removeEventListener(UPDATE_PARTNER_TRACKING_PIXEL,this.updateTrackingPixel);window.removeEventListener(UPDATE_PARTNER_APPLICATION_STATE,this.updateApplicationState);window.removeEventListener(UPDATE_PARTNER_OMITTED,this.updateOmit);}},{key:"render",value:function render(){var _partner$config$heade,_partner$config,_partner$config$heade2,_partner$config$heade3,_partner$config$heade4,_partner$config2,_partner$config2$head,_partner$config2$head2,_partner$config$theme,_partner$config3,_partner$config4,_partner$config$track,_partner$config5,_partner$config$head$,_partner$config6,_partner$config6$head,_partner$config7,_partner$config7$head;var _this$props=this.props,appName=_this$props.appName,partner=_this$props.partner,children=_this$props.children,env=_this$props.env;var applicationState=this.state.applicationState;if(!children){return null;}if(!partner||!partner.config){return children;}var responsiveProps={smallMinBreakpoint:(_partner$config$heade=partner===null||partner===void 0?void 0:(_partner$config=partner.config)===null||_partner$config===void 0?void 0:(_partner$config$heade2=_partner$config.header)===null||_partner$config$heade2===void 0?void 0:(_partner$config$heade3=_partner$config$heade2.small)===null||_partner$config$heade3===void 0?void 0:_partner$config$heade3.minBreakpoint)!==null&&_partner$config$heade!==void 0?_partner$config$heade:'xs',largeMinBreakpoint:(_partner$config$heade4=partner===null||partner===void 0?void 0:(_partner$config2=partner.config)===null||_partner$config2===void 0?void 0:(_partner$config2$head=_partner$config2.header)===null||_partner$config2$head===void 0?void 0:(_partner$config2$head2=_partner$config2$head.large)===null||_partner$config2$head2===void 0?void 0:_partner$config2$head2.minBreakpoint)!==null&&_partner$config$heade4!==void 0?_partner$config$heade4:'lg'};var theme=es((_partner$config$theme=partner===null||partner===void 0?void 0:(_partner$config3=partner.config)===null||_partner$config3===void 0?void 0:_partner$config3.theme)!==null&&_partner$config$theme!==void 0?_partner$config$theme:{},{flyQueries:{mobile:'@media screen and (max-width: 413px)',mobilelg:'@media screen and (min-width: 414px)',tablet:'@media screen and (min-width: 600px)',tabletlg:'@media screen and (min-width: 768px)',tablethd:'@media screen and (min-width: 840px)',desktop:'@media screen and (min-width: 1024px)',desktoplg:'@media screen and (min-width: 1280px)',desktophd:'@media screen and (min-width: 1440px)'}});var everyMundo=partner===null||partner===void 0?void 0:(_partner$config4=partner.config)===null||_partner$config4===void 0?void 0:_partner$config4.everyMundo;var isEnvValid=env&&(env==='qa'||env==='prod');var trackingPixels=(_partner$config$track=partner===null||partner===void 0?void 0:(_partner$config5=partner.config)===null||_partner$config5===void 0?void 0:_partner$config5.trackingPixels)!==null&&_partner$config$track!==void 0?_partner$config$track:[];return/*#__PURE__*/react.createElement(PartnerContext.Provider,{value:(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({appName:appName},partner),{},{env:env,updateTrackingPixel:this.updateTrackingPixel,updateApplicationState:this.updateApplicationState,updateOmit:this.updateOmit})},!this.shouldOmit('trackingPixels')&&isEnvValid&&trackingPixels.map(function(pixel,idx){var type=pixel.type;var Pixel=pixelTypes[type];return/*#__PURE__*/react.createElement(Pixel,(0,esm_extends/* default */.Z)({key:type+idx,env:env},pixel.props,{type:type,applicationState:applicationState}));}),!this.shouldOmit('headScripts')&&((_partner$config$head$=partner===null||partner===void 0?void 0:(_partner$config6=partner.config)===null||_partner$config6===void 0?void 0:(_partner$config6$head=_partner$config6.head)===null||_partner$config6$head===void 0?void 0:_partner$config6$head.scripts)!==null&&_partner$config$head$!==void 0?_partner$config$head$:[]).map(function(script){return/*#__PURE__*/react.createElement(ScriptLoader/* default */.Z,{key:script,url:script,applicationState:applicationState});}),env==='prod'&&!this.shouldOmit('headScripts')&&everyMundo&&everyMundo.applications.includes(appName)&&/*#__PURE__*/react.createElement(ScriptLoader/* default */.Z,{key:"everyMundo",url:everyMundo.script}),!this.shouldOmit('headScripts')&&(partner===null||partner===void 0?void 0:(_partner$config7=partner.config)===null||_partner$config7===void 0?void 0:(_partner$config7$head=_partner$config7.head)===null||_partner$config7$head===void 0?void 0:_partner$config7$head.links)&&/*#__PURE__*/react.createElement(Helmet/* default */.ZP,null,partner.config.head.links.map(function(_ref2,i){var href=_ref2.href,props=(0,objectWithoutProperties/* default */.Z)(_ref2,_excluded);return/*#__PURE__*/react.createElement("link",(0,esm_extends/* default */.Z)({key:i},props,{href:href&&(0,replaceApplicationStatePlaceholders/* default */.Z)(href,applicationState)}));})),/*#__PURE__*/react.createElement(ThemeProvider/* ThemeProvider */.f,{theme:theme},/*#__PURE__*/react.createElement(ResponsiveContext/* default.Provider */.Z.Provider,{value:responsiveProps},/*#__PURE__*/react.createElement(SSOProvider/* default */.ZP,{env:env},children))));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,prevState){var nextState={applicationState:(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({},prevState.applicationState),{},{random:PartnerProvider.getApplicationState().random,pageType:PartnerProvider.getApplicationState().pageType,type:PartnerProvider.getApplicationState().type}),prevApplicationProps:(0,objectSpread2/* default */.Z)({},prevState.prevApplicationProps)};if((0,esm_typeof/* default */.Z)(nextProps.trackingPixelParameters)==='object'){Object.keys(nextProps.trackingPixelParameters).forEach(function(key){if(nextProps.trackingPixelParameters[key]!==prevState.prevApplicationProps[key]){nextState.applicationState[key]=nextProps.trackingPixelParameters[key];nextState.prevApplicationProps[key]=nextProps.trackingPixelParameters[key];}});}if((0,esm_typeof/* default */.Z)(nextProps.applicationState)==='object'){Object.keys(nextProps.applicationState).forEach(function(key){if(!['random','pageType','type'].includes(key)&&nextProps.applicationState[key]!==prevState.prevApplicationProps[key]){nextState.applicationState[key]=nextProps.applicationState[key];nextState.prevApplicationProps[key]=nextProps.applicationState[key];}});}return nextState;}},{key:"getApplicationState",value:function getApplicationState(){var _global$window$locati,_global,_global$window,_global$window$locati2,_global$window$naviga,_global2,_global2$window;/* istanbul ignore next */var pageType=getPageType((_global$window$locati=(_global=__webpack_require__.g)===null||_global===void 0?void 0:(_global$window=_global.window)===null||_global$window===void 0?void 0:(_global$window$locati2=_global$window.location)===null||_global$window$locati2===void 0?void 0:_global$window$locati2.href)!==null&&_global$window$locati!==void 0?_global$window$locati:'');var navigator=(_global$window$naviga=(_global2=__webpack_require__.g)===null||_global2===void 0?void 0:(_global2$window=_global2.window)===null||_global2$window===void 0?void 0:_global2$window.navigator)!==null&&_global$window$naviga!==void 0?_global$window$naviga:{};var deviceType=utils_isMobileDevice(navigator)?'mobile':'desktop';return{random:Math.floor(Math.random()*Date.now())+Date.now(),pageType:pageType,type:getType(pageType),lang:((typeof window==="undefined"?"undefined":(0,esm_typeof/* default */.Z)(window))==='object'&&window.localStorage&&window.localStorage.getItem('i18nextLng')||'en-us').toLowerCase(),amount:null,currency:null,orderId:null,device:deviceType,departingDate:null,endDate:null,origin:null,destination:null,numAdults:null,numPassengers:null,advancedPurchase:null,flyStartDate:null,flyEndDate:null,flyConfirmationNumber:null,originAirportCode:null,destinationAirportCode:null,value:null,components:null};}}]);return PartnerProvider;}(react.Component);PartnerProvider.defaultProps={componentStyles:[],omit:false};PartnerProvider.propTypes={appName:(prop_types_default()).string,partner:prop_types_default().shape({plfCode:(prop_types_default()).string,partnerCode:(prop_types_default()).string.isRequired,config:prop_types_default().shape({trackingPixels:(prop_types_default()).array,head:prop_types_default().shape({scripts:prop_types_default().arrayOf((prop_types_default()).string),links:prop_types_default().arrayOf(prop_types_default().shape({rel:(prop_types_default()).string,href:(prop_types_default()).string,crossorigin:(prop_types_default()).string}))}),header:prop_types_default().shape({small:prop_types_default().shape({minBreakpoint:(prop_types_default()).string}),large:prop_types_default().shape({minBreakpoint:(prop_types_default()).string})}),oneTrust:prop_types_default().shape({domainScript:(prop_types_default()).Object}),theme:(prop_types_default()).object.isRequired,everyMundo:(prop_types_default()).object})}),renderTrackingPixel:(prop_types_default()).bool,trackingPixelParameters:(prop_types_default()).object,componentStyles:prop_types_default().arrayOf(prop_types_default().shape({component:(prop_types_default()).func.isRequired,style:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).func]).isRequired}).isRequired),applicationState:shapes/* applicationStateShape */.Y1,omit:prop_types_default().oneOfType([(prop_types_default()).bool,prop_types_default().arrayOf(prop_types_default().oneOf(['trackingPixels','headScripts']))]),children:(prop_types_default()).node,env:function env(props,propName,componentName){if(props['partner']!==undefined&&props[propName]===undefined){return new Error(// prettier-ignore
"The prop `".concat(propName,"` is marked as required in `").concat(componentName,"` when a partner exists, but its value is `undefined`."));}if(typeof props[propName]!=='string'){return new Error(// prettier-ignore
"Invalid prop `".concat(propName,"` of type `").concat((0,esm_typeof/* default */.Z)(props[propName]),"` supplied to `").concat(componentName,"`, expected `string`."));}}};PartnerProvider.displayName='PartnerProvider';PartnerContext.displayName='PartnerContext';/* harmony default export */ var models_PartnerProvider = (PartnerProvider);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p8": function() { return /* binding */ SSOContext; }
/* harmony export */ });
/* unused harmony export initialContext */
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86854);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_usePartner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40383);
var initialContext={env:'prod',isEnabled:false,isSignedIn:false,profile:{fields:{},data:{}}};var SSOContext=/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContext);function SSOProvider(_ref){var _ssoConfig$profile;var env=_ref.env,children=_ref.children;var ssoConfig=(0,_hooks_usePartner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('config.sso');var _useState=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((ssoConfig===null||ssoConfig===void 0?void 0:ssoConfig.isSignedIn)===true),_useState2=(0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState,2),isSignedIn=_useState2[0],setIsSignedIn=_useState2[1];var profileData;if(ssoConfig!==null&&ssoConfig!==void 0&&ssoConfig.isEnabled&&isSignedIn){profileData=(0,_hooks_usePartner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('profile');}var props=(0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({env:env},ssoConfig),{},{isSignedIn:isSignedIn,profile:(0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({},(ssoConfig===null||ssoConfig===void 0?void 0:ssoConfig.profile)||{}),{},{data:(0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({},(ssoConfig===null||ssoConfig===void 0?void 0:(_ssoConfig$profile=ssoConfig.profile)===null||_ssoConfig$profile===void 0?void 0:_ssoConfig$profile.data)||{}),profileData||{})}),handleSignOut:function handleSignOut(callback){setIsSignedIn(false);typeof callback==='function'&&callback();}});return/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SSOContext.Provider,{value:props},children);}SSOProvider.displayName='SSOProvider';SSOProvider.propTypes={env:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),children:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)};/* harmony default export */ __webpack_exports__["ZP"] = (SSOProvider);
//# sourceMappingURL=SSOProvider.js.map

/***/ }),

/***/ 3043:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Get a value from an nested object
 *
 * @param {Object}  object Object that we want to query from
 * @param {String} path query path for that object in form of "path.to.object"
 * @param {any} defaultValue default value to be returned if path does not exist
 *
 * @returns {Object} value if found. otherwise, return default value or undefined
 *//* harmony default export */ __webpack_exports__["Z"] = (function(object,path,defaultValue){if(!path){return defaultValue;}var pathArray=path.split('.');return pathArray.reduce(function(prevPath,nextPath){var _prevPath$nextPath;return(_prevPath$nextPath=prevPath===null||prevPath===void 0?void 0:prevPath[nextPath])!==null&&_prevPath$nextPath!==void 0?_prevPath$nextPath:defaultValue;},object);});
//# sourceMappingURL=getByPath.js.map

/***/ }),

/***/ 98012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* eslint-disable no-prototype-builtins */var replaceApplicationStatePlaceholders=function replaceApplicationStatePlaceholders(data,applicationState){if(typeof data==='string'){;(data.match(/({.+?})/g)||[]).forEach(function(placeholder){if(Object.prototype.hasOwnProperty.call(applicationState,placeholder.slice(1,-1))){data=data.replace(placeholder,applicationState[placeholder.slice(1,-1)]||'');}else{data=data.replace(placeholder,'');}});return data;}else if(Array.isArray(data)){return data.map(function(param){if((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param)==='object'){return replaceApplicationStatePlaceholders(param,applicationState);}return /^{.+}$/.test(param)?applicationState[param.slice(1,-1)]:param;});}else if((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data)==='object'){data=(0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({},data);for(var param in data){if(Object.prototype.hasOwnProperty.call(data,param)&&/^{.+}$/.test(data[param])&&applicationState.hasOwnProperty(data[param].slice(1,-1))){data[param]=applicationState[data[param].slice(1,-1)];}}return data;}return{};};/* harmony default export */ __webpack_exports__["Z"] = (replaceApplicationStatePlaceholders);
//# sourceMappingURL=replaceApplicationStatePlaceholders.js.map

/***/ }),

/***/ 73242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ stringOrNumber; },
/* harmony export */   "Wf": function() { return /* binding */ alignmentTypes; },
/* harmony export */   "Y1": function() { return /* binding */ applicationStateShape; },
/* harmony export */   "CG": function() { return /* binding */ headerLinkShape; },
/* harmony export */   "Dj": function() { return /* binding */ headerNavigationShape; }
/* harmony export */ });
/* unused harmony exports deviceTypes, screenSizes, largeHeaderShape, smallHeaderShape, headerShape, configShape, partnerShape */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
var deviceTypes=prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf(['mobile','desktop']);var screenSizes=prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf(['xs','sm','md','lg','xl']);var stringOrNumber=prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)]);var alignmentTypes=prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf(['left','center','right']);var applicationStateShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({advancedPurchase:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),amount:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),currency:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),departingDate:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),destination:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),destinationAirportCode:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),device:deviceTypes,endDate:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),flyEndDate:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),flyStartDate:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),flyConfirmationNumber:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),lang:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),numAdults:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),numPassengers:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),orderId:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),origin:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),originAirportCode:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),pageType:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),random:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),type:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),value:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),components:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)});var headerLinkShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({label:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),href:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),iconName:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)});var headerNavigationShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({label:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),href:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),iconName:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),links:prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(headerLinkShape),isMobileOnly:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool)});var largeHeaderShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({minBreakpoint:screenSizes,height:stringOrNumber,color:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),backgroundColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),dropdownColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),linkAlignment:alignmentTypes});var smallHeaderShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({minBreakpoint:screenSizes,height:stringOrNumber,color:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),iconColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),backgroundColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),dropdownColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),menuColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),menuHeaderColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),menuBackgroundColor:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),menuButtonAlignment:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),logoAlignment:alignmentTypes});var headerShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({logoPath:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),logoHref:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),logoTitle:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),secondaryLogoPath:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),secondaryLogoHref:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),secondaryLogoTitle:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),linksOpenNewTab:(prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool),large:largeHeaderShape,small:smallHeaderShape,navigation:prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(headerNavigationShape)});var configShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({header:headerShape});var partnerShape=prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({config:configShape});
//# sourceMappingURL=shapes.js.map

/***/ }),

/***/ 69590:
/***/ (function(module) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 15482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = true;
__webpack_unused_export__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(83524);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(69590);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(62994);

var _HelmetConstants = __webpack_require__(74455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {}

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

__webpack_unused_export__ = HelmetExport;
exports.ZP = HelmetExport;

/***/ }),

/***/ 74455:
/***/ (function(__unused_webpack_module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 62994:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(96086);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(74455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : __webpack_require__.g.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : __webpack_require__.g.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;

/***/ }),

/***/ 83524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(96774));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 35666:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 86854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

}]);